/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolSchemaStaticValue,
  ToolSchemaStaticValue$inboundSchema,
} from "./toolschemastaticvalue.js";

/**
 * Static values found in one tool input schema.
 */
export type ToolSchemaStaticValues = {
  /**
   * The tool name
   */
  toolName: string;
  /**
   * The tool URN
   */
  toolUrn: string;
  /**
   * Static values in the tool input schema
   */
  values: Array<ToolSchemaStaticValue>;
};

/** @internal */
export const ToolSchemaStaticValues$inboundSchema: z.ZodMiniType<
  ToolSchemaStaticValues,
  unknown
> = z.pipe(
  z.object({
    tool_name: z.string(),
    tool_urn: z.string(),
    values: z.array(ToolSchemaStaticValue$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tool_name": "toolName",
      "tool_urn": "toolUrn",
    });
  }),
);

export function toolSchemaStaticValuesFromJSON(
  jsonString: string,
): SafeParseResult<ToolSchemaStaticValues, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolSchemaStaticValues$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolSchemaStaticValues' from JSON`,
  );
}
